export function trimSlashes(str: string) {
    let start = 0;
    let end = str.length - 1;

    while (str[start] === '/') {
        start++;
    }

    while (str[end] === '/' && end > start) {
        end--;
    }

    if (end - start < 0) return '';

    return str.slice(start, end + 1);
}
